import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AppFeatureName, AppState } from './app.reducer';

export const getAppState = createFeatureSelector<AppState>(AppFeatureName);

const getSidebarStatus = createSelector(
  getAppState,
  (state) => state.sidebarPinned
);

const isFullScreenMode = createSelector(
  getAppState,
  (state) => state.isFullScreenMode
);

const isAppOnline = createSelector(
  getAppState,
  (state) => state.isAppOnline && !state.isAppLockedInOffline
);
const isAppOnlineRealState = createSelector(
  getAppState,
  (state) => state.isAppOnline
);

const getLoginPageDisplayed = createSelector(
  getAppState,
  (state) => state.loginPageDisplayed
);

const getRedirectedToCore = createSelector(
  getAppState,
  (state) => state.redirectedToCore
);

const isLoading = createSelector(getAppState, (state) => state.isLoading);

const isAppLockedInOffline = createSelector(
  getAppState,
  (state) => state.isAppLockedInOffline
);

const getDprsSortingDirection = createSelector(
  getAppState,
  (state) => state.dprsSortingDirection
);

const getReportDownloadsInProgress = createSelector(
  getAppState,
  (state) => state.reportDownloads
);

export const appQuery = {
  getSidebarStatus,
  isFullScreenMode,
  isAppOnline,
  isAppOnlineRealState,
  getLoginPageDisplayed,
  getRedirectedToCore,
  isLoading,
  isAppLockedInOffline,
  getDprsSortingDirection,
  getReportDownloadsInProgress,
};
